import React, { FC, useState } from 'react';

import lang from '../../../lib/language';

import BaseModal from '../../../shared_components/BaseModal/BaseModal';
import Button from '../../../shared_components/Button/Button';

import styles from './ExpiredVerificationModal.module.scss';

type Props = {
  forceNoRender?: boolean;
  noModalDisplay?: boolean;
}
const ExpiredVerificationModal: FC<Props> = (props: Props) => {
  const { noModalDisplay, forceNoRender } = props;
  const [showModal, setShowModal] = useState<boolean>(true);

  if (forceNoRender) {
    return <></>;
  }

  const content: JSX.Element = (
    <div className={styles.text}>{lang.commonOnboardingExpiredVerificationLinkBody()}</div>
  );

  return noModalDisplay ? content : (
    <BaseModal isOpen={showModal}>
      <div className={styles.title}>{lang.commonOnboardingExpiredVerificationLinkTitle()}</div>
        {content}
        <div className={styles.buttonsWrapper}>
          <Button
            fullWidth
            className={styles.button}
            onClick={() => setShowModal(false)}
            >
            {lang.commonOkay()}
          </Button>
        </div>
    </BaseModal>
  );
};

export default ExpiredVerificationModal;
